














import { Vue, Component } from 'vue-property-decorator';
import FlagUtil from '@/util/FlagUtil';

import ToastNotification from '@/components/ToastNotification/index.vue';
import ToastModule from '@/store/modules/toast';
import NotificationPane from '@/components/NotificationPane/index.vue';
import navigation from './navigation.vue';
import appbar from './appbar.vue';

@Component({
  components: {
    appbar,
    navigation,
    ToastNotification,
    NotificationPane,
  },
})
export default class AppLayout extends Vue {
  get notifsEnabled() {
    return FlagUtil.hasFeature('notifications');
  }
}
